import {CancellationRequestStatus, CancellationResultType} from '../types/cancellationRequest.types'

import {normalizeCancellationRequestStatus} from './normalizeCancellationRequestStatus'

export const resolveCancellationPollingResult = (
  request: CancellationRequestStatus | null | undefined,
  submittedRequestId: string
): CancellationResultType | undefined => {
  if (!request || request.requestId !== submittedRequestId) return undefined

  const status = normalizeCancellationRequestStatus(request.status)

  if (status === 'completed') return 'success'
  if (status === 'failed') return 'failure'

  return undefined
}
